import { AsyncPipe, DOCUMENT, Location, NgClass, NgStyle } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  signal,
} from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatStep, MatStepLabel, MatStepper, MatStepperIcon } from "@angular/material/stepper";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LoadingService } from "@core/loading.service";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { LottieComponent } from "ngx-lottie";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { auditTime, take, takeUntil } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { PaymentService } from "src/app/services/payment.service";
import { VoucherService } from "src/app/services/vouchers.service";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { CountDownTimerComponent } from "../../../components/count-down-timer/count-down-timer.component";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { DayPipe } from "../../../pipe/day";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { RedirectUriComponent } from "../redirect-uri/redirect-uri.component";
import { StorePaymentComponent } from "../store-payment/store-payment.component";
import { StoreRepositoryService } from "../store-repository.service";
import { CheckoutPaymentService } from "./services/checkout-payment-service";
import { CheckoutFramesService } from "./services/checkout-frames-service";
import { CheckoutVoucherService } from "./services/checkout-voucher-service";
import { CheckoutUpsellService } from "./services/checkout-upsell-service";
import { CardOfferService } from "./services/card-offer-service";
import { CheckoutAnalyticsService } from "./services/checkout-analytics-service";
import { CheckoutPostPaymentService } from "./services/checkout-post-payment-service";
import { ExitIntentService } from "./services/exit-intent-service";


declare var window;

@Component({
  selector: "app-add-card",
  templateUrl: "./add-card.component.html",
  styleUrls: ["./add-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  providers:[CheckoutPaymentService, CheckoutFramesService, CheckoutVoucherService, CheckoutUpsellService, CardOfferService, CheckoutAnalyticsService, CheckoutPostPaymentService, ExitIntentService],
  imports: [
    IonicModule,
    MatStepper,
    MatStep,
    MatStepLabel,
    FormsModule,
    SwiperModule,
    CountDownTimerComponent,
    LottieComponent,
    NgClass,
    NgStyle,
    MatStepperIcon,
    MatIcon,
    InProgressAnimationComponent,
    AsyncPipe,
    DisplayCurrencyPipe,
    DayPipe,
    SafeHtmlPipe,
    TranslatePipe],
})
export class AddCardComponent implements OnInit, OnDestroy {
  @ViewChild("stepper", { static: false }) stepper: MatStepper;
  @ViewChild("iframe", { static: false }) iframe: ElementRef;
  @ViewChild("checkOutIframe", { static: false }) checkOutIframe: ElementRef;
  @ViewChild("timer", { static: false }) timerspan: ElementRef;
  isChecked = signal<boolean>(false);
  private destroy$ = new Subject<void>();
  latestDate: Date | null = null;
  showAll = false;
  @Inject(MAT_DIALOG_DATA) public data: Data;
  speed: number;
  public autoSlide: boolean;
  @ViewChild("slider") slider: SwiperComponent;
  journeyId: number;
  seconds!: number;
  expiry_in_minutes!: number;
  expireInMin = 5;
  timeLeft = this.expireInMin * 60;
  displayResponse: Data;
  private subscription!: Subscription;
  selectedCard = "10";
  cardArrlength: number;
  eventbody: Data;
  proceed = true;
  sub = new Subscription();
  spinnerAnimation: boolean;
  progressBar: number;
  selectedCardData: object;
  latestCardData: object;
  storedCards = [];
  failToast: string;
  successToast: string;
  updatedFailureToast: string;
  updatedSuccessToast: string;
  tp1: string;
  tp2: string;
  tp3: string;
  t_id: string;
  prosub_id: string | number;
  cardOfferDetails: Data[] = [];
  currentOfferCard: string;
  other: number | string;
  promotions: Data[] = [];
  processingStates: boolean[] = Array(this.promotions.length).fill(false);
  cardOfferpurchaseDetail = {} as Data;
  activeCardIndex: number[] = [];

  timerOn = true;
  timeOut: boolean;
  storePaymentData: {};

  firstInput = 5;
  compRef: ComponentRef<RedirectUriComponent>;

  offer_link_id: any;
  firstFormGroup: FormGroup;
  stepperIndex = 0;
  purchaseDetail$ = new BehaviorSubject(null);
  checkout_description: string;
  isPaymentDone = false;
  price;
  responseObject: Data;
  addNewCardInProgress: boolean = false;
  doneCheckoutCreation: boolean = false;
  pathString: any;
  payment_status: any;
  paymentReceived: boolean;
  privateSyndicateTicket$: any;
  isPaymill: boolean = true;
  isSecureTrading: boolean = false;
  isCheckoutCom = false;
  isCheckoutComform = true;
  redirectlink: Data;
  checkOutComData: Data;
  showCheckOutComSpinner = false;
  public isButtonDisabled: boolean;
  public upsellList: Data[];
  public upsell_ID: string;
  public paymentOfferID: string;
  public addonAmount: Data[];
  public checkedValues: number[];
  public updatedPrizeValue: number;
  public totalAmount: number;
  public upsellAmount: number;
  public checkedValuesDefaultCurrency: number[];
  public errorMessage: string;
  public token: string;
  public keys: Data;
  public errorStack: string[] = [];
  public language: string;
  public getCheckOutComResponseSubscription: Subscription;
  public generateCheckoutTokenSubscription: Subscription;
  countdownInterval: ReturnType<typeof setInterval> | null = null;
  customerPurchaseEncryptedId: Data;
  show_iframe: any = false;
  callback: string;
  translatedToastMsg: any;
  translatedToastMsgSignal = signal<any>([]);
  selectedLanguage: string = CommonVariable.preferredLanguage;
  selectedLanguageSignal = signal<string>(CommonVariable.preferredLanguage);
  minutes: number;
  /* Master card */
  purchaseDetail = {} as any;

  PaReq: string;
  TermUrl: string;
  MD: string;
  cachetoken = "";
  callType = 1;
  sqlAPICallResponse: any;
  origin = window.location.origin;
  /* Master card */
  preferredCurrency: string = CommonVariable.preferredCurrency;
  preferredCurrencySignal = signal<string>(CommonVariable.preferredCurrency);
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  currencySymbolSignal = signal<string>(CommonVariable.defaultCurrencySymbol);
  stepperIframe: MatStepper;
  customOfferCashbackText = "";
  customOfferAwardId = 0;
  customOfferAwardIdSubscription: Subscription;
  receivedData: Data;
  paymentReason = "";
  public cardTokenizedSubject = new Subject<Data>();
  private cardTokenizedSubscription: Subscription;
  public currentNdc: string;
  public currentNdcSignal = signal<string>("");
  public paymentReceivedFromCP = false;
  private unsubscribeStatusFromCP$: Subject<void> = new Subject<void>();
  private unsubscribeStatusFromPayment$: Subject<void> = new Subject<void>();
  private unsubscribe$ = new Subject<void>();
  public cardTokenizedCalled = false;
  public checkoutFlowReady = false;
  private storeTabUrl = "/mainTabs/tabs/store";
  public checkoutComPtype = "21";
  public fbTokenKey = "fbToken";
  public userIdKey = "userId";
  tokenValidaterSub: Subscription;
  upsellSummaryArray: Data[];
  public paymentHold = false;
  storeSliderOptions1: SwiperOptions = {
    autoplay: false,
    speed: 500,
    spaceBetween: 0,
    // Keep 1.5 on desktop too: checkout column is phone-width; slidesPerView:1 stretched the ticket past the summary and clipped Apply.
    slidesPerView: 1.5,
    centerInsufficientSlides: true,
    edgeSwipeThreshold: 4,
    grabCursor: true,
  };
  public discountVouchersStatus = false;
  discountVouchersData: Data[] = [];
  public selectedDiscountValue = 0;
  public selectedDiscountVoucherData: Data | null = null;
  /** Set while Checkout.com Flow remounts for a voucher discount change. */
  public suppressVoucherUiReset = false;
  public addCardPaymentStatus = false;
  public expiryCheckInterval!: Subscription;
  public paymentFailRedirectionStatus = false;
  public storeString = "store";
  userData: Data;
  public framesInitRetryCount = 0;
  public framesInitRetryDelay = 5000;
  public framesInitMaxRetry = 3;
  timeoutId: NodeJS.Timeout;
  showVisaInfoHTML = "";
  paymentMode: string;

  constructor(
    public changeDetRef: ChangeDetectorRef,
    private _formBuilder: FormBuilder,
    private paymentService: PaymentService,
    public actRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private modalController: ModalController,
    private authService: AuthService,
    public translate: TranslateService,
    private storeService: StoreRepositoryService,
    private loadingService: LoadingService,
    private voucherService: VoucherService,
    private checkoutPaymentService: CheckoutPaymentService,
    private checkoutFramesService: CheckoutFramesService,
    private checkoutVoucherService: CheckoutVoucherService,
    private checkoutUpsellService: CheckoutUpsellService,
    private cardOfferService: CardOfferService,
    private checkoutAnalyticsService: CheckoutAnalyticsService,
    @Inject(DOCUMENT) private document: Document,
    private cdRef: ChangeDetectorRef,
    private checkoutPostPaymentService: CheckoutPostPaymentService,
    private exitIntentService: ExitIntentService,
  ) {
    this.cardTokenizedSubscription = this.cardTokenizedSubject
      .pipe(
        auditTime(3000),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((event) => {
        this.processCardToken(event);
      });
    this.minutes = 600;
    this.upsellList = [];
    this.addonAmount = [];
    this.upsellSummaryArray = [];
    this.checkedValues = [];
    this.updatedPrizeValue = 0;
    this.checkedValuesDefaultCurrency = [];
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService.selectedlanguage$
      ?.pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (l) => {
          if (l) {
            this.selectedLanguageSignal.set(l ? l : CommonVariable?.preferredLanguage);
            this.selectedLanguage = this.selectedLanguageSignal();
            translate.use(l ? l : CommonVariable?.preferredLanguage);
          }
        },
        error: (err) => {
          return err;
        },
      });

    this.authService.getConstantsMsg$
      .pipe(takeUntil(this.destroy$))
      .subscribe((msg) => {
        this.translatedToastMsgSignal.set(msg?.static_messages_pwa);
        this.translatedToastMsg = this.translatedToastMsgSignal();
      });

    this.authService?.userDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (user) => {
          this.userData = user;
          this.preferredCurrencySignal.set(user?.preferred_currency ?? CommonVariable.preferredCurrency);
          this.preferredCurrency = this.preferredCurrencySignal();
          this.authService.getCurrencyList$
            ?.pipe(takeUntil(this.destroy$))
            .subscribe((data: Data) => {
              const CurrencyDetails = data?.details?.find(
                (x) => x?.currency_code === this.preferredCurrencySignal()
              );
              this.currencySymbolSignal.set(
                CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol
              );
              this.currencySymbol = this.currencySymbolSignal();
            });
        },
        error: (err) => {
          return err;
        },
      });

    this.timer(this.minutes);
    this.storeService.customOfferCashBackText$.subscribe(
      (text: string) => {
        this.customOfferCashbackText = text;
      },
      (err) => {
        return err;
      }
    );

    this.customOfferAwardIdSubscription = this.storeService.customOfferAwardId$.subscribe(
      (awardId: number) => {
        this.customOfferAwardId = awardId;
      },
      (err) => {
        return err;
      }
    );
    this.paymentService.getCurrentNdcId().subscribe(
      (ndcId) => {
        this.currentNdcSignal.set(ndcId);
        this.currentNdc = this.currentNdcSignal();
      },
      (err) => {
        return err;
      }
    );
  }

  @HostListener("window:message", ["$event"])
  onMessage(e): void {
    if (e && e?.data && e?.data?.for === "paymentDone") {
      // To check for active current session or manually login using token
      this.authService.commonUserCheck(() => {
        this.checkoutPaymentService.afterNewCardPaymentDone(this.stepperIframe,this);
      });
    }
  }
  ngOnInit() {
    this.exitIntentService.loadSegmentData();
    this.checkoutPaymentService.loadCards(this);
    this.fetchOrderData();
    this.redirectlink = null;
    this.storePaymentData = this.router.getCurrentNavigation()?.extras?.state;
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });

    // To decide the page flow based on the redirection from 3DS approval page
    const currentRoute = localStorage.getItem("currentRoute");
    const isPaymentDone = localStorage.getItem("isPaymentDone");
    if (currentRoute && isPaymentDone === "true") {
      localStorage.removeItem("currentRoute");
      localStorage.removeItem("isPaymentDone");
      this.paymentHold = true;
      this.isPaymentDone = false;
      this.addNewCardInProgress = true;
    } else {
      const currentUrl = this.router.url;
      localStorage.setItem("currentRoute", currentUrl);
      localStorage.removeItem("d");
    }

    const qp = this.actRoute.snapshot?.queryParams ?? {};
    this.paymentMode = qp.pt ?? "";
    if (this.checkoutFramesService.handleCheckoutFlowRedirectReturn(this)) {
      return;
    }
    this.actRoute.params.subscribe(
      (d) => {
        this.pathString = d?.time;
        if (!this.pathString) return;

        if (!this.paymentHold) {
          this.checkoutPaymentService.initPaymentDocument(this);
        }
        this.checkoutPaymentService.initSyndicateRequest(this);
      },
      (err) => err
    );

    window.addEventListener('beforeunload', this.handleRefresh);

    const allOngoingFalse = localStorage.getItem('allOngoingFalse') || false;
    if (allOngoingFalse == "true") {
      this.translate.get(["add-card"]).subscribe((res) => {
        this.showVisaInfoHTML = `<div class="info-banner">
            <span class="info-icon">ℹ️</span>
            <p>${res["add-card"]["visa_nudge"]}</p>
          </div>`;
      });
    } else {
      this.showVisaInfoHTML = '';
    }
  }

  handleExitIntentPopup() {
  this.exitIntentService.handleExitIntent(this);
}


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.customOfferAwardIdSubscription?.unsubscribe();
    window.removeEventListener('beforeunload', this.handleRefresh);
    this.expiryCheckInterval?.unsubscribe();
    // Unsubscribe to prevent memory leaks
    this.generateCheckoutTokenSubscription?.unsubscribe();
    this.getCheckOutComResponseSubscription?.unsubscribe();

    // Properly clean up cardTokenizedSubject subscription
    this.cardTokenizedSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.cardTokenizedSubject.complete();
    this.checkoutFramesService.unmount();

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  // this can be used to implement logic which is necessary when the user refreshes the page
  handleRefresh = (event: BeforeUnloadEvent): void => {
    this.resetDiscountVoucherHideStatus();
  };

  count = 0;
  load(e, stepper) {
    this.checkoutPaymentService.load(
      e,
      stepper,
      this,
      () => this.afterNewCardPaymentDoneUpdatedCallback()
    );
  }

  private afterNewCardPaymentDoneUpdatedCallback(): void {
    // This callback can be used for additional logic after payment update
  }

  afterNewCardPaymentDoneUpdated(stepper) {
    this.checkoutPaymentService.afterNewCardPaymentDoneUpdated(stepper, this);
  }

  resetPaymentSubscriptions(): void {
    this.unsubscribeStatusFromCP$?.next();
    this.unsubscribeStatusFromCP$?.complete();
    this.unsubscribeStatusFromPayment$?.next();
    this.unsubscribeStatusFromPayment$?.complete();
  }

  private manualLogin(token: string): Promise<any> {
    return this.checkoutPaymentService.manualLoginPrivate(token, this);
  }

  async viewTicket(page: string) {
    this.addNewCardInProgress = true;
    this.checkoutPostPaymentService.viewTicket(this,page)
  }

  fetchSyndicateAndShowTicket() {
    this.storeService.customOfferCashBackText$.next("");
    this.storeService.customOfferAwardId$.next(0);
    this.checkoutPostPaymentService.fetchSyndicateAndShowTicket(this)
  }

  private redirectToSyndicateAfterPayment(encrypt_syndicate_id?: string): void {
    this.voucherService.setSyndicatePending().pipe(take(1)).subscribe();
    this.router.navigate(["mainTabs/tabs/syndicate"], { state: { encrypt_syndicate_id } });
  }


  // openConfirmationPopup() {
  //   const confirmationDialog = this.matDialog.open(CheckoutConfirmationComponent, {
  //     panelClass: "mysterybox-dialog-size",
  //     backdropClass: "mysterybox-back-drop-color",
  //     hasBackdrop: true,
  //     disableClose: false,
  //   });

  //   confirmationDialog
  //     .afterClosed()
  //     .pipe(takeUntil(this.unsubscribe$))
  //     .subscribe({
  //       next: (response: boolean) => {
  //         // We are going back to previous page if the user selects that he is not interested.
  //         if (response) {
  //           this.goBack();
  //         }
  //       },
  //       error: (error) => {
  //         return error;
  //       },
  //     });
  // }

  goBack() {
    this.resetDiscountVoucherHideStatus();
    this.voucherService.updateDiscountVoucherHideStatus(this.selectedDiscountVoucherData?.id, false);
    this.storeService.customOfferCashBackText$.next("");
    this.storeService.customOfferAwardId$.next(0);
    this.storeService.userBackout$.next(true);
    this.location.back();
  }
  async timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    // document.getElementById("timer").innerHTML = m + ":" + s;
    if (this.timerspan) {
      this.timerspan.nativeElement.innerHTML = m + ":" + s;
    }
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      this.timeoutId = setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timeOut = true;
    // this.addingCard = false;
    this.addNewCardInProgress = false;
    // this.showAddNewCard = true;
    //this.authService.showToast("Session timeout has occur, Please try again!", "Error", "");
    this.authService
      .getConstantsMsg("1100")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Session timeout has occur, Please try again!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      })
      .catch((err) => {
        return err;
      });

    if (this.storePaymentData) {
      const modal = await this.modalController.create({
        component: StorePaymentComponent,
        componentProps: {
          data: this.storePaymentData,
        },
      });
      modal
        .present()
        .then((d) => {
          this.location.back();
          return;
        })
        .catch((error) => {
          return error;
        });
    }

    //alert("Timeout for otp");
  }
  public showCreditIssueToast(): void {
    this.checkoutPostPaymentService.showCreditIssueToast(this)

  }

  public ngAfterViewInit(): void {
    this.isButtonDisabled = true;

    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        const lang = l ? l : "en";

        switch (lang) {
          case "en":
            this.language = "EN-GB";
            break;
          case "de":
            this.language = "DE-DE";
            break;
          case "es":
            this.language = "ES-ES";
            break;
          case "fr":
            this.language = "FR-FR";
            break;
          case "it":
            this.language = "IT-IT";
            break;
          default:
            this.language = "EN-GB";
        }
      },
      (err) => {
        this.language = "EN-GB";
        return err;
      }
    );
    const queryParam = this.actRoute.snapshot.queryParams || {};
    this.showCheckOutComSpinner = true;
    this.cdRef.detectChanges();
    this.checkoutFramesService.loadCheckoutApiAndInitialize(this, queryParam);
  }

  public initializeFrames(): void {
    this.checkoutFramesService.initializeFrames(
      this,
      this.keys,
      this.language
    );
  }

  public onCardValidationChanged(): void {
    this.checkoutFramesService.onCardValidationChanged(this);
  }

  public onValidationChanged(event: Data): void {
    this.checkoutFramesService.onValidationChanged(event, this);
  }

  public getErrorMessage(element: string): string {
    return this.checkoutFramesService.getErrorMessage(element);
  }

  public onCardTokenizationFailed(): void {
    this.checkoutFramesService.onCardTokenizationFailed();
  }

  public processCardToken(event: Data): void {
    this.checkoutPaymentService.processCardToken(event, this, this.cdRef);
  }

  public onSubmit(event: Event): void {
    this.checkoutFramesService.onSubmit(event);
  }

  public onCheckoutFlowPaymentCompleted(): void {
    this.addNewCardInProgress = true;
    this.showCheckOutComSpinner = true;
    this.isCheckoutComform = false;
    this.isButtonDisabled = true;
    this.changeDetRef.detectChanges();
    this.checkoutPaymentService.handleFlowPaymentConfirmation(this, this.cdRef);
  }

  public isCheckoutLoadingMessage(message: string): boolean {
    return this.checkoutFramesService.isCheckoutLoadingMessage(message);
  }

  /**
   * Handles the order success event by collecting relevant data and sending it to GTM.
   */
  orderSuccessEvent() {
    this.checkoutAnalyticsService.orderSuccessEvent(this);
  }

  public getCookie(name) {
    try {
      var nameEQ = name + "=";
      var cookie = document.cookie?.split(";");
      for (var i = 0; i < cookie.length; i++) {
        var c = cookie[i];
        while (c.charAt(0) == " ") c = c?.substring(1, c.length);
        if (c?.indexOf(nameEQ) == 0) return c?.substring(nameEQ.length, c.length);
      }
      return null;
    } catch (e) {
      return e;
    }
  }
  // get upsell data
  getUpsellData(upsell_ID: string, selectedUpsells?: Data[]) {
    this.checkoutUpsellService.getUpsellData(this, upsell_ID, selectedUpsells);
  }

  // on checkbox change
  checkBoxChanged(event: Data, offerData: Data) {
    this.checkoutUpsellService.checkBoxChanged(this, event, offerData);
  }

  public async unloadPaymentWidget(): Promise<void> {
    this.checkoutFramesService.unloadPaymentWidget()
  }

  cardOfferDisabled(index: number) {
    return this.cardOfferService.cardOfferDisabled(this, index);
  }

  storeSliderOptions2: SwiperOptions = {
    speed: 500,
    slidesPerView: 1.15,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination-2",
      clickable: true,
    },
    // Disabled: slides contain CTA buttons that navigate away. Swiper's rAF callback races
    // with ionViewWillLeave(), leaving params undefined. Explicit false prevents regressions
    // if Swiper defaults or shared configs change. LOTTOSOCIAL-PWA-1NCK
    slideToClickedSlide: false,
    autoplay: {
      delay: 5000,
    },
  };

  slides: Swiper;
  interval;
  setSwiperInstance(swiper) {
    this.slides = swiper;

    // Clear any existing intervals
    clearInterval(this.interval);

    // Start a new interval after a delay to check and control autoplay
    setTimeout(() => {
      this.interval = setInterval(() => {
        // Check if slides or autoplay is undefined
        if (!this.slides || !this.slides.autoplay) {
          return;
        }

        if (!this.autoSlide) {
          // If autoSlide is false, stop autoplay
          this.slides?.autoplay?.stop();
        } else {
          // If autoSlide is true, start or resume autoplay
          this.slides.slideNext(this.speed);
          this.slides.autoplay.start();
        }
      }, 4500);
    }, 4500);
  }

  prev() {
    try {
      this.slider?.swiperRef?.slidePrev(500);
    } catch (e) {
      return e;
    }
  }

  next() {
    try {
      this.slider?.swiperRef?.slideNext(500);
    } catch (e) {
      return e;
    }
  }
  cardOfferPayment(item: Data, index: number) {
    this.cardOfferService.cardOfferPayment(this, item, index);
  }

  getCheckCardDetailId() {
    return this.cardOfferService.getCheckCardDetailId(this);
  }

  //this fucnction is used to process payments for the confirmation page card offers
  cardofferProceedToPay(index: number) {
    this.cardOfferService.cardofferProceedToPay(this, index);
  }


  startCountdown() {
    this.cardOfferService.startCountdown(this);
  }


  async fetchOrderData() {
    return this.cardOfferService.fetchOrderData(this);
  }


  initilizEvent(data: Data) {
    this.checkoutAnalyticsService.initilizEvent(this, data);
  }

  private checkoutPaymentFailedFlow(): void {
    this.checkoutPaymentService.checkoutPaymentFailedFlow(this);
  }

  /**
   * The function `redirectToPreviousPage` retrieves the previous page from the server and navigates to
   * it using Angular Router, falling back to a default URL if there is an error or no previous page is
   * found.
   */
  redirectToPreviousPage(): void {
    this.checkoutPaymentService.redirectToPreviousPage();
  }

  checkAndUpdateStylesForIframe(): void {
    this.checkoutFramesService.checkAndUpdateStylesForIframe(this.checkOutIframe);
  }

  public fetchDiscountVouchersData() {
    this.checkoutVoucherService.fetchDiscountVouchersData(this);
  }

  private startDiscountVouchersExpiryCheck() {
    this.checkoutVoucherService.startDiscountVouchersExpiryCheck(this);
  }

  onVoucherSelect(event: Data, selectedVoucher: Data) {
    this.checkoutVoucherService.onVoucherSelect(event, selectedVoucher, this);
  }

  private resetDiscountVoucherHideStatus() {
    this.checkoutVoucherService.resetDiscountVoucherHideStatus(this);
  }

  private resetDiscountAmountOnVoucherExpiry(voucher: Data): void {
    this.checkoutVoucherService.resetDiscountAmountOnVoucherExpiry(this, voucher);
  }

  private resetVouchersUI() {
    this.checkoutVoucherService.resetVouchersUI(this);
  }

  private updateExpiryTextInVoucher(expiredVoucher: Data): void {
    this.checkoutVoucherService.updateExpiryTextInVoucher(this, expiredVoucher);
  }
}
